import { validateForm } from "../setup";
import {
  showFormProcessing,
  endFormProcessing,
  showSubmissionText,
  handleUncontrolledSubmitButton,
} from "./util";
import { postSubmitToDBPipe } from "../postSubmit";

//  return false based on API
const defaultFormOnSuccess = ($form, formValues, $controlledSubmitButton) => {
  showSubmissionText($controlledSubmitButton);
  handleUncontrolledSubmitButton(showSubmissionText);
  endFormProcessing($controlledSubmitButton);
  handleUncontrolledSubmitButton(endFormProcessing);
  setTimeout(() => {
    postSubmitToDBPipe($form, formValues);
  }, 300);
  return false;
};

export const formDefaultSubmitPipe = ($form) => async (e) => {
  e.preventDefault();
  const $inputEls = $form.find("input, select, textarea");
  const $controlledSubmitButton = $form.find("button[type=submit]");

  showFormProcessing($controlledSubmitButton);
  handleUncontrolledSubmitButton(showFormProcessing);

  //  1. JS validation
  const { isValidated, values } = validateForm($inputEls);
  const formValues = values;

  if (!isValidated) {
    endFormProcessing($controlledSubmitButton);
    handleUncontrolledSubmitButton(endFormProcessing);
    return;
  }

  defaultFormOnSuccess($form, formValues, $controlledSubmitButton);
};
